package com.zaurh.mapquizwebsite.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class GetDailyRewardsDO(
    val rewards: List<DailyRewardDO>,
    val action: String,
    val nextClaimAt: Long? = null
)

@Serializable
enum class DailyRewardAction {
    CLAIM,
    TIMER
}

fun String.toDailyRewardAction(): DailyRewardAction {
    return when (this) {
        "CLAIM" -> DailyRewardAction.CLAIM
        "TIMER" -> DailyRewardAction.TIMER
        else -> throw IllegalArgumentException("Unknown DailyRewardAction: $this")
    }
}